
import { defineComponent, ref, onMounted } from 'vue';
import { getPermissionCodes } from '@/utils/permission';
import { usePermission } from '@/composables/usePermission';
import { getMenuList } from '@/utils/auth';

export default defineComponent({
  name: 'PermissionTest',
  setup() {
    const { hasPermission } = usePermission();
    const permissionCodes = ref<string[]>([]);
    const menuListData = ref<any>(null);
    
    onMounted(() => {
      console.log('=== 权限测试页面加载 ===');
      
      // 获取菜单数据
      menuListData.value = getMenuList();
      console.log('菜单数据:', menuListData.value);
      
      // 获取权限列表
      permissionCodes.value = getPermissionCodes();
      console.log('权限列表:', permissionCodes.value);
      
      // 测试权限函数
      console.log('测试 sysAds.list.update:', hasPermission('sysAds.list.update'));
      console.log('测试 test.fake.permission:', hasPermission('test.fake.permission'));
    });
    
    return {
      permissionCodes,
      menuListData,
      hasPermission,
    };
  },
});
